import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { environment } from "../../../../environments/environment";
import * as moment from "moment";

@Component({
  selector: "app-editinquiry",
  templateUrl: "./editinquiry.component.html",
  styleUrls: ["./editinquiry.component.css"],
})
export class EditinquiryComponent implements OnInit {
  isDisabled: boolean = false;
  Qvalue: any;
  rqdReason: boolean = false;
  active: string = "tab-selectbyid1";
  currencyName: any;
  ReplicaRef: number;
  RL: boolean = false;
  LostReasonDes: any;
  rqdReasonDes: boolean = false;
  ReceivedDate: any;
  Rvalue: any;
  DPeriod: any;
  AppName: any;
  QMargin: any;
  LMargin: any;
  SMargin: any;
  RvsnNote: any;
  reasonDes: any;
  userRId: any;
  disableDate() {
    return false;
  }
  registerForm: FormGroup;
  duplicateForm: FormGroup;
  isCollapsed: any;
  activitytype: any = "activity";
  submitted = false;
  userid: any;
  InquiryId: number = 0;
  id: any;
  showProjectArray: any = [];
  showInquiryArray: any = [];
  showCustomerArray: any = [];
  showContractorArray: any = [];
  showMainContractorArray: any = [];
  showConsultantArray: any = [];
  showSupervisionArray: any = [];
  showStageArray: any = [];
  showProbabilityArray: any = [];
  showQuotationErArray: any = [];
  showSalesErArray: any = [];
  businessVerticalArray: any = [];
  showcategoryArray: any = [];
  showReasonArray: any = [];
  showRevisionArray: any = [];
  showProjectSourceArray: any = [];
  showTerritoryArray: any = [];

  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  dropdownSetting5: any = {};
  dropdownSetting6: any = {};
  dropdownSetting7: any = {};
  dropdownSetting8: any = {};
  dropdownSetting9: any = {};
  dropdownSetting10: any = {};
  dropdownSetting11: any = {};
  dropdownSetting12: any = {};
  dropdownSetting13: any = {};
  dropdownSetting14: any = {};
  dropdownSetting15: any = {};
  dropdownSetting16: any = {};
  dropdownSetting17: any = {};
  dropdownSetting18: any = {};

  permission: any;
  inquirydoc: any;
  QuoteMargin: number = 0.0;
  LOIMargin: any = 0;
  SOMargin: any = 0;
  IqrNum: any;
  type: any;
  isMediabtnClicked: boolean;
  mediaUploadDisplay: boolean;
  totalMediaSize: any;
  totalMediaLength: number;
  modalRef: BsModalRef;
  config: {
    class: "modal-dialog-centered";
    backdrop: true;
    ignoreBackdropClick: true;
  };
  upload_disable: boolean;
  preview: string;
  fileUpload: any[];
  imgURL: any[];
  mediaPostTextTemp: string;
  mediaPostLoader: boolean;
  mediaPostArr: {};
  allowDragover: boolean;
  postTextWithLink: string;
  sharePostArr: {};
  urlMediaTitle: any;
  urlTitle: any;
  urlMediaDescription: any;
  urlDescription: any;
  urlMediaImage: any;
  urlImage: any;
  urlMediaLink: any;
  urlLink: any;
  iframe: any;
  isPrivacySettingsMediaPostBtnEnable: boolean;
  fileUploadCount: number;
  postMediaGreaterThanCheckError: string;
  file_upload_loader: boolean;
  videoURL: any[];
  isImagePasted: boolean;
  pasteEvnetStatus: boolean;
  fileUploadLoader: boolean;
  clicked: boolean;
  dft_icn: string;
  url: string;
  downloadurl: string;
  inqId: any;
  filename: any;
  file: any;
  delNameDel: boolean;
  inquirydata: any;
  Lost: boolean = false;
  won: boolean = false;
  loi: boolean = false;
  QtM: boolean = true;
  Pname: any;
  Iname: any;
  QuotedDate: any;
  ExpODate: any;
  drFlag: boolean;
  Pnumber: any;
  Inumber: any;
  newId: any = "";
  maxDate: any;
  minDate: any;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private UserService: UserService
  ) {
    this.active = localStorage.getItem("active_id");
    let decid = this.route.snapshot.params["id"];
    decid = decid
      .toString()
      .replace("Ar1t", "=")
      .replace("FGH", "/")
      .replace("THD", "+");
    localStorage.setItem("editiqrid", decid);

    this.id = this.UserService.decryptData(decid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
  }

  validNumber = new RegExp(/^\d*\.?\d*$/);

  ngOnInit(): void {
    this.url = environment.tempimage;
    this.downloadurl = environment.app_download_path;
    this.dft_icn = environment.default_temp;
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Inquiry_Edit != 1 && this.userRId != 1) {
      this.toastr.error("You do not have permission");
      this.router.navigate(["/profile"]);
    }

    this.dropdownSetting1 = {
      singleSelection: true,
      text: "Project Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting2 = {
      singleSelection: true,
      text: "Inquiry Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting3 = {
      singleSelection: true,
      text: "Customer Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting4 = {
      singleSelection: true,
      text: "MEP Contractor",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting5 = {
      singleSelection: true,
      text: "Main Contractor",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting6 = {
      singleSelection: true,
      text: "Design Consultant",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting7 = {
      singleSelection: true,
      text: "Supervision Consultant",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting8 = {
      singleSelection: true,
      text: "Stages",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting9 = {
      singleSelection: true,
      text: "Probability",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting10 = {
      singleSelection: true,
      text: "Quotation Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting11 = {
      singleSelection: true,
      text: "Sales Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting12 = {
      singleSelection: true,
      text: "Business Verticals",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
      disabled: true,
    };

    this.dropdownSetting13 = {
      singleSelection: true,
      text: "Business Category",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting14 = {
      singleSelection: true,
      text: "Reason",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting15 = {
      singleSelection: true,
      text: "Select Revision",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: "1",
    };

    this.dropdownSetting16 = {
      singleSelection: true,
      text: "Project Source",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting17 = {
      singleSelection: true,
      text: "Territory",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting18 = {
      singleSelection: true,
      text: "Lost To Company",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.registerForm = this.formBuilder.group({
      ProjectId: [""],
      ProjectName: [""],
      InquiryId: [""],
      InquiryName: [""],
      CustomerName: ["", Validators.required],
      MEPContractor: [""],
      MainContractor: [""],
      DesignConsultant: [""],
      SupervisionConsultant: [""],
      StageId: ["", Validators.required],
      InquiryProbability: ["", Validators.required],
      ReceivedDate: ["", Validators.required],
      QuotationEngineerId: ["", Validators.required],
      SalesEngineerId: ["", Validators.required],
      BusinessVertical: ["", Validators.required],
      BusinessCategory: [""],
      QuotedValue: [""],
      ReportedValue: [""],
      QuotedDate: [""],
      DeliveryPeriod: [""],
      IncoTerms: [""],
      Application: [""],
      ExpOrderDate: [""],
      LostTo: [""],
      Reason: [""],
      LostReason: [""],
      QuoteMargin: [
        0.0,
        [
          Validators.max(100),
          Validators.min(0),
          Validators.pattern(this.validNumber),
        ],
      ],
      LOIMargin: [""],
      SOMargin: [""],
      Revision: [""],
      RevisionNote: [""],
    });

    let data = {
      InquiryId: this.id,
      Mode: "Edit",
    };
    this.spinner.show();
    this.UserService.GetInquiryDetailById(data).subscribe(
      (res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.IqrNum = res["Data"]["InquiryNumber"];
          this.InquiryId = res["Data"]["InquiryId"];
          this.inquirydoc = res["UploadDocument"];
          this.inquirydata = res["Data"];
          this.currencyName = res["Data"]["currencyName"];
          this.ReplicaRef = res["Data"]["ReplicaReference"];
          if (res["Data"]["CustomerId"]) {
            this.selectedcustomer = [
              {
                id: res["Data"]["CustomerId"],
                itemName: res["Data"]["CustomerName"],
              },
            ];
          }
          this.selectedcustomer.forEach((element) => {
            this.selectedCustomer = element["itemName"];
            this.selectedCustomerId = element["id"];
          });

          if (res["Data"]["LostToId"]) {
            this.selectedcompany = [
              {
                id: res["Data"]["LostToId"],
                itemName: res["Data"]["LostToCompanyName"],
              },
            ];
          }
          this.selectedcompany.forEach((element) => {
            this.selectedCompany = element["itemName"];
            this.selectedCompanyId = element["id"];
          });

          if (res["Data"]["CompanyId_MEP"]) {
            this.selectedcontractor = [
              {
                id: res["Data"]["CompanyId_MEP"],
                itemName: res["Data"]["CompanyName_MEP"],
              },
            ];
          }
          this.selectedcontractor.forEach((element) => {
            this.selectedContractor = element["itemName"];
            this.selectedContractorId = element["id"];
          });

          if (res["Data"]["CompanyId_Main"]) {
            this.selectedmaincontractor.push({
              id: res["Data"]["CompanyId_Main"],
              itemName: res["Data"]["CompanyName_Main"],
            });
          }
          this.selectedmaincontractor.forEach((element) => {
            this.selectedMainContractor = element["itemName"];
            this.selectedMainContractorId = element["id"];
          });

          this.registerForm
            .get("MainContractor")
            .setValue(this.selectedmaincontractor);

          if (res["Data"]["CompanyId_Design"]) {
            this.selectedconsultant = [
              {
                id: res["Data"]["CompanyId_Design"],
                itemName: res["Data"]["CompanyName_Design"],
              },
            ];
          }
          this.selectedconsultant.forEach((element) => {
            this.selectedConsultant = element["itemName"];
            this.selectedConsultantId = element["id"];
          });

          if (res["Data"]["CompanyId_Super"]) {
            this.selectedsupervision = [
              {
                id: res["Data"]["CompanyId_Super"],
                itemName: res["Data"]["CompanyName_Super"],
              },
            ];
          }
          this.selectedsupervision.forEach((element) => {
            this.selectedSupervision = element["itemName"];
            this.selectedSupervisionId = element["id"];
          });

          if (res["Data"]["StageId"]) {
            this.selectedstage = [
              {
                id: res["Data"]["StageId"],
                itemName: res["Data"]["StageName"],
              },
            ];
            if (res["Data"]["StageId"] <= 4) {
              this.drFlag = false;
            } else {
              this.drFlag = true;
            }
            if (res["Data"]["StageId"] > 6 && res["Data"]["StageId"] < 10) {
              this.loi = true;
              this.registerForm.controls?.LOIMargin?.setValidators(
                this.setRequired()
              );
            } else {
              this.loi = false;
              this.registerForm.controls?.LOIMargin?.clearValidators();
            }
            if (res["Data"]["StageId"] == 10) {
              this.won = true;
              this.registerForm.controls.SOMargin?.setValidators(
                this.setRequired()
              );
            } else {
              this.won = false;
              this.registerForm.controls.SOMargin?.clearValidators();
            }
            if (res["Data"]["StageId"] == 11) {
              this.Lost = true;
              this.registerForm.controls.LostTo.setValidators(
                this.setRequired1()
              );
            } else {
              this.Lost = false;
              this.registerForm.controls.LostTo.clearValidators();
            }
            if (res["Data"]["StageId"] <= 6 || res["Data"]["StageId"] >= 11) {
              this.QtM = true;
            } else {
              this.QtM = false;
            }
          }
          this.selectedstage.forEach((element) => {
            this.selectedStage = element["itemName"];
            this.selectedStageId = element["id"];
          });

          if (res["Data"]["InquiryProbabilityId"]) {
            this.selectedprobability = [
              {
                id: res["Data"]["InquiryProbabilityId"],
                itemName: res["Data"]["Percentage"],
              },
            ];
          }
          this.selectedprobability.forEach((element) => {
            this.selectedProbability = element["itemName"];
            this.selectedProbabilityId = element["id"];
          });

          if (res["Data"]["QuotationEngineerId"]) {
            this.selectedquotationEr = [
              {
                id: res["Data"]["QuotationEngineerId"],
                itemName: res["Data"]["QuotationEngineerName"],
              },
            ];
          }
          this.selectedquotationEr.forEach((element) => {
            this.selectedQuotationEr = element["itemName"];
            this.selectedQuotationErId = element["id"];
          });

          if (res["Data"]["SalesEngineerId"]) {
            this.selectedsalesEr = [
              {
                id: res["Data"]["SalesEngineerId"],
                itemName: res["Data"]["SalesEngineerName"],
              },
            ];
          }
          this.selectedsalesEr.forEach((element) => {
            this.selectedSalesEr = element["itemName"];
            this.selectedSalesErId = element["id"];
          });

          if (res["Data"]["BusinessVerticalId"]) {
            this.selectedBusiness = [
              {
                id: res["Data"]["BusinessVerticalId"],
                itemName: res["Data"]["BusinessVerticalName"],
              },
            ];
          }
          this.selectedBusiness.forEach((element) => {
            this.selectedBusinessName = element["itemName"];
            this.selectedBusinessNameId = element["id"];
          });

          if (res["Data"]["BusinessCategoryId"]) {
            this.selectedcategory = [
              {
                id: res["Data"]["BusinessCategoryId"],
                itemName: res["Data"]["BusinessCategoryName"],
              },
            ];
          }
          this.selectedcategory.forEach((element) => {
            this.selectedCategory = element["itemName"];
            this.selectedCategoryId = element["id"];
          });

          if (res["Data"]["ReasonId"]) {
            this.selectedreason = [
              {
                id: res["Data"]["ReasonId"],
                itemName: res["Data"]["ReasonName"],
              },
            ];
          }
          this.selectedreason.forEach((element) => {
            this.selectedReason = element["itemName"];
            this.selectedReasonId = element["id"];
          });

          if (this.selectedReasonId == 6) {
            this.RL = true;
          } else {
            this.RL = false;
          }

          if (res["Data"]["RevisionId"]) {
            this.selectedrevision2 = [
              {
                id: res["Data"]["RevisionId"],
                itemName: res["Data"]["RevisionName"],
              },
            ];
          }
          this.selectedrevision2.forEach((element) => {
            this.selectedRevision2 = element["itemName"];
            this.selectedRevisionId2 = element["id"];
          });

          this.Pname = res["Data"]["ProjectName"];
          this.Iname = res["Data"]["InquiryName"];
          this.Pnumber = res["Data"]["ProjectNumber"];
          this.Inumber = res["Data"]["InquiryNumber"];

          this.QuotedDate = res["Data"]["QuotedDate"];
          if (this.QuotedDate) {
            this.minDate = new Date(
              moment(this.QuotedDate, "DD-MM-YYYY").format("MM-DD-YYYY")
            );
            this.QuotedDate = moment(this.QuotedDate, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            );
          }

          this.ReceivedDate = res["Data"]["ReceivedDate"];
          this.Qvalue = res["Data"]["TotalSalesValue"];
          this.Rvalue = res["Data"]["TotalTotalPriceQAR"];
          this.DPeriod = res["Data"]["DeliveryPeriodName"];
          this.AppName = res["Data"]["ApplicationName"];
          this.ExpODate = res["Data"]["ExpOrderDate"];

          this.QMargin = res["Data"]["QuoteMargin"];
          this.LMargin = res["Data"]["LOIMargin"];
          this.SMargin = res["Data"]["SOMargin"];
          this.RvsnNote = res["Data"]["RevisionNote"];
          this.reasonDes = res["Data"]["LostReason"];

          this.registerForm.patchValue({
            InquiryName:
              res["Data"]["InquiryName"] +
              " (" +
              res["Data"]["InquiryNumber"] +
              ")",
            ProjectId: res["Data"]["ProjectId"],
            ProjectName:
              res["Data"]["ProjectName"] +
              " (" +
              res["Data"]["ProjectNumber"] +
              ")",
            ReceivedDate: res["Data"]["ReceivedDate"],
            // QuotedValue: res["Data"]["TotalSalesValue"],
            QuotedValue: res["Data"]["TotalPriceWithVat"],
            // ReportedValue: res["Data"]["TotalTotalPriceQAR"],
            ReportedValue: res["Data"]["TotalPriceQARWithVat"],
            ExpOrderDate: res["Data"]["ExpOrderDate"],
            DeliveryPeriod: res["Data"]["DeliveryPeriodName"],
            Application: res["Data"]["ApplicationName"],
            LostTo: res["Data"]["LostTo"],
            LostReason: res["Data"]["LostReason"],
            QuoteMargin: res["Data"]["QuoteMargin"],
            LOIMargin: res["Data"]["LOIMargin"],
            SOMargin: res["Data"]["SOMargin"],
            RevisionNote: res["Data"]["RevisionNote"],
          });
          this.getstage();
          if (res["Data"]["LOIMargin"] == 0) {
            this.registerForm.get("LOIMargin").setValue("");
          }
          if (res["Data"]["SOMargin"] == 0) {
            this.registerForm.get("SOMargin").setValue("");
          }
        } else {
          this.spinner.hide();
          this.toastr.error(res["Msg"]);
        }
      },
      (error) => {
        this.toastr.error(error["Message"]);
      }
    );

    this.getproject();
    this.getcustomer();
    this.getprobability();
    this.getquotationEr();
    this.getsalesEr();
    this.getBusinessVertical();
    this.getreason();
    this.getRevision();

    this.duplicateForm = this.formBuilder.group({
      ProjectId: [""],
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  getInquiryDetails() {
    let data = {
      InquiryId: this.id,
      Mode: "Edit",
    };
    this.spinner.show();
    this.UserService.GetInquiryDetailById(data).subscribe((res) => {
      this.IqrNum = res["Data"]["InquiryNumber"];
      this.InquiryId = res["Data"]["InquiryId"];
      this.inquirydoc = res["UploadDocument"];
      this.inquirydata = res["Data"];
      this.spinner.hide();
    });
  }

  showRevision: any = [];
  getRevision() {
    let data = {};
    this.spinner.show();
    this.UserService.GetRevisionList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showRevisionArray = res;
        this.showRevision = [];
        for (const revision of this.showRevisionArray["Data"]) {
          this.showRevision.push({
            id: revision["RevisionId"],
            itemName: revision["Name"],
          });
        }
      } else {
        this.showRevisionArray = [];
      }
    });
  }

  selectedrevision2 = [];
  selectedRevision2: any;
  selectedRevisionId2: number = 0;
  onRevisionSelect2(item: any) {
    this.selectedRevision2 = "";
    this.selectedRevisionId2 = 0;
    this.selectedrevision2.forEach((element) => {
      this.selectedRevision2 = element["itemName"];
      this.selectedRevisionId2 = element["id"];
    });
  }

  showProject: any = [];
  getproject() {
    let data = {};
    this.UserService.GetAllProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProjectArray = res;
        this.showProject = [];
        for (const project of this.showProjectArray["Data"]) {
          if (
            project["Status"] == 1 &&
            (project["ProjectStatus"] == 4 || project["ProjectStatus"] == 6)
          ) {
            this.showProject.push({
              id: project["ProjectId"],
              itemName: `${project["ProjectName"]} (${project["ProjectNumber"]})`,
            });
          }
        }
      } else {
        this.showProjectArray = [];
      }
    });
  }
  selectedproject: any = [];
  selectedProject: any;
  selectedProjectId: number = 0;
  onProjectSelect(item: any) {
    this.selectedProject = "";
    this.selectedProjectId = 0;
    this.selectedproject.forEach((element) => {
      this.selectedProject = element["itemName"];
      this.selectedProjectId = element["id"];
    });
  }

  showCustomer: any = [];
  showContractor: any = [];
  showMainContractor: any = [];
  showConsultant: any = [];
  showSupervision: any = [];
  showLostToCompany: any = [];
  getcustomer() {
    let data = {};
    this.UserService.GetAllCustomer(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showCustomerArray = res;
        this.showCustomer = [];
        this.showLostToCompany = [];
        for (const customer of this.showCustomerArray["CustomerName"]) {
          const companyId = customer["CompanyId"];
          const companyName = customer["CompanyName"];
          this.showCustomer.push({
            id: companyId,
            itemName: companyName,
          });
          this.showLostToCompany.push({
            id: companyId,
            itemName: companyName,
          });
        }

        this.showContractorArray = res;
        this.showContractor = [];
        for (const contractor of this.showContractorArray["MEPContractor"]) {
          this.showContractor.push({
            id: contractor["CompanyId"],
            itemName: contractor["CompanyName"],
          });
        }

        this.showMainContractorArray = res;
        this.showMainContractor = [];
        for (const mainContractor of this.showMainContractorArray[
          "MainContractor"
        ]) {
          this.showMainContractor.push({
            id: mainContractor["CompanyId"],
            itemName: mainContractor["CompanyName"],
          });
        }

        this.showConsultantArray = res;
        this.showConsultant = [];
        for (const consultant of this.showConsultantArray["Designonsultant"]) {
          this.showConsultant.push({
            id: consultant["CompanyId"],
            itemName: consultant["CompanyName"],
          });
        }

        this.showSupervisionArray = res;
        this.showSupervision = [];
        for (const supervision of this.showSupervisionArray[
          "SupervisionConsultant"
        ]) {
          this.showSupervision.push({
            id: supervision["CompanyId"],
            itemName: supervision["CompanyName"],
          });
        }
      } else {
        this.showCustomerArray = [];
        this.showContractorArray = [];
        this.showMainContractorArray = [];
        this.showConsultantArray = [];
        this.showSupervisionArray = [];
        this.showLostToCompany = [];
      }
    });
  }
  selectedcustomer: any = [];
  selectedCustomer: any = "";
  selectedCustomerId: number = 0;
  onCustomerSelect(item: any) {
    this.selectedCustomer = "";
    this.selectedCustomerId = 0;
    this.selectedcustomer.forEach((element) => {
      this.selectedCustomer = element["itemName"];
      this.selectedCustomerId = element["id"];
    });
  }
  selectedcompany: any = [];
  selectedCompany: any = "";
  selectedCompanyId: number = 0;
  onCompanySelect(item: any) {
    this.selectedCompany = "";
    this.selectedCompanyId = 0;
    this.selectedcompany.forEach((element) => {
      this.selectedCompany = element["itemName"];
      this.selectedCompanyId = element["id"];
    });
  }
  selectedcontractor: any = [];
  selectedContractor: any;
  selectedContractorId: number = 0;
  onContractorSelect(item: any) {
    this.selectedContractor = "";
    this.selectedContractorId = 0;
    this.selectedcontractor.forEach((element) => {
      this.selectedContractor = element["itemName"];
      this.selectedContractorId = element["id"];
    });
  }
  selectedmaincontractor: any = [];
  selectedMainContractor: any;
  selectedMainContractorId: number = 0;
  onMainContractorSelect(item: any) {
    this.selectedMainContractor = "";
    this.selectedMainContractorId = 0;
    this.selectedMainContractor = item.itemName;
    this.selectedMainContractorId = item.id;
  }
  selectedconsultant: any = [];
  selectedConsultant: any;
  selectedConsultantId: number = 0;
  onConsultantSelect(item: any) {
    this.selectedConsultant = "";
    this.selectedConsultantId = 0;
    this.selectedconsultant.forEach((element) => {
      this.selectedConsultant += element["itemName"];
      this.selectedConsultantId += element["id"];
    });
  }
  selectedsupervision: any = [];
  selectedSupervision: any;
  selectedSupervisionId: number = 0;
  onSupervisionSelect(item: any) {
    this.selectedSupervision = "";
    this.selectedSupervisionId = 0;
    this.selectedsupervision.forEach((element) => {
      this.selectedSupervision += element["itemName"];
      this.selectedSupervisionId += element["id"];
    });
  }

  showStage: any = [];
  getstage() {
    let data = {};
    this.UserService.GetStageList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showStageArray = res;
        this.showStage = [];
        for (const stageData of this.showStageArray["Data"]) {
          if (stageData["Status"] == 1 && stageData["StageId"] < 15) {
            if (this.Qvalue != null) {
              this.showStage.push({
                id: stageData["StageId"],
                itemName: stageData["StageName"],
              });
            } else if (
              stageData["StageId"] <= 4 ||
              stageData["StageId"] >= 11
            ) {
              this.showStage.push({
                id: stageData["StageId"],
                itemName: stageData["StageName"],
              });
            }
          }
        }
      } else {
        this.showStageArray = [];
      }
    });
  }
  selectedstage: any = [];
  selectedStage: any;
  selectedStageId: number = 0;
  onStageSelect(item: any) {
    this.selectedStage = "";
    this.selectedStageId = 0;
    this.selectedstage.forEach((element) => {
      this.selectedStage += element["itemName"];
      this.selectedStageId += element["id"];
    });

    if (this.selectedStageId > 6 && this.selectedStageId < 10) {
      this.loi = true;
      this.registerForm.controls.LOIMargin?.setValidators(this.setRequired());
    } else {
      this.loi = false;
      this.registerForm.controls.LOIMargin?.clearValidators();
    }
    if (this.selectedStageId == 10) {
      this.won = true;
      this.registerForm.controls.SOMargin?.setValidators(this.setRequired());
    } else {
      this.won = false;
      this.registerForm.controls.SOMargin?.clearValidators();
    }
    if (this.selectedStageId == 11) {
      this.Lost = true;
      this.registerForm.controls.LostTo.setValidators(this.setRequired1());
    } else {
      this.Lost = false;
      this.registerForm.controls.LostTo.clearValidators();
    }
    if (this.selectedStageId <= 6 || this.selectedStageId >= 11) {
      this.QtM = true;
    } else {
      this.QtM = false;
    }
  }

  setRequired() {
    return [
      Validators.required,
      Validators.max(100),
      Validators.min(0),
      Validators.pattern(this.validNumber),
    ];
  }
  setRequired1() {
    return [Validators.required];
  }

  showProbability: any = [];
  getprobability() {
    let data = {};
    this.UserService.GetInquiryProbabilityList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProbabilityArray = res;
        this.showProbability = [];
        for (const probabilityData of this.showProbabilityArray["Data"]) {
          this.showProbability.push({
            id: probabilityData["InquiryProbabilityId"],
            itemName: probabilityData["Percentage"],
          });
        }
      } else {
        this.showProbabilityArray = [];
      }
    });
  }
  selectedprobability: any = [];
  selectedProbability: any;
  selectedProbabilityId: number = 0;
  onProbabilitySelect(item: any) {
    this.selectedProbability = "";
    this.selectedProbabilityId = 0;
    this.selectedprobability.forEach((element) => {
      this.selectedProbability += element["itemName"];
      this.selectedProbabilityId += element["id"];
    });
  }

  showQuotationEr: any = [];
  getquotationEr() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showQuotationErArray = res;
        this.showQuotationEr = [];
        for (const quotationErData of this.showQuotationErArray["Data"]) {
          this.showQuotationEr.push({
            id: quotationErData["UserId"],
            itemName: `${quotationErData["UserName"]} (${quotationErData["EmailId"]}) ${quotationErData["EmployeeId"]}`,
          });
        }
      } else {
        this.showQuotationErArray = [];
      }
    });
  }
  selectedquotationEr: any = [];
  selectedQuotationEr: any;
  selectedQuotationErId: number = 0;
  onQuotationErSelect(item: any) {
    this.selectedQuotationEr = "";
    this.selectedQuotationErId = 0;
    this.selectedquotationEr.forEach((element) => {
      this.selectedQuotationEr = element["itemName"];
      this.selectedQuotationErId = element["id"];
    });
  }

  showSalesEr: any = [];
  getsalesEr() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showSalesErArray = res;
        this.showSalesEr = [];
        for (const salesErData of this.showSalesErArray["Data"]) {
          this.showSalesEr.push({
            id: salesErData["UserId"],
            itemName: `${salesErData["UserName"]} (${salesErData["EmailId"]}) ${salesErData["EmployeeId"]}`,
          });
        }
      } else {
        this.showSalesErArray = [];
      }
    });
  }
  selectedsalesEr: any = [];
  selectedSalesEr: any;
  selectedSalesErId: number = 0;
  onSalesErSelect(item: any) {
    this.selectedSalesEr = "";
    this.selectedSalesErId = 0;
    this.selectedsalesEr.forEach((element) => {
      this.selectedSalesEr = element["itemName"];
      this.selectedSalesErId = element["id"];
    });
  }

  businessVertical: any = [];
  getBusinessVertical() {
    let data = {};
    this.UserService.GetBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.businessVerticalArray = res;
        this.businessVertical = [];
        for (const verticalData of this.businessVerticalArray["Data"]) {
          this.businessVertical.push({
            id: verticalData["Id"],
            itemName: verticalData["Name"],
          });
        }
      } else {
        this.businessVerticalArray = [];
      }
    });
  }
  selectedBusiness: any = [];
  selectedBusinessName: string = "";
  selectedBusinessNameId: number = 0;
  onBusinessSelect(item: any) {
    this.selectedBusinessName = "";
    this.selectedBusinessNameId = 0;
    this.selectedBusiness.forEach((element) => {
      this.selectedBusinessName = element["itemName"];
      this.selectedBusinessNameId = element["id"];
    });
    this.showcategory = [];
    this.selectedcategory = [];
    this.GetBusinessCategory(this.selectedBusinessNameId);
  }

  showcategory: any = [];
  GetBusinessCategory(id) {
    let data = {
      BusinessVertical: id,
    };
    this.UserService.GetBusinessCategory(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showcategoryArray = res;
        this.showcategory = [];
        for (const categoryData of this.showcategoryArray["Data"]) {
          this.showcategory.push({
            id: categoryData["BusinessCategoryId"],
            itemName: categoryData["Name"],
          });
        }
      } else {
        this.showcategoryArray = [];
      }
    });
  }

  selectedcategory: any = [];
  selectedCategory: string = "";
  selectedCategoryId: number = 0;
  onCategorySelect(item: any) {
    this.selectedCategory = "";
    this.selectedCategoryId = 0;
    this.selectedcategory.forEach((element) => {
      this.selectedCategory += element["itemName"];
      this.selectedCategoryId += element["id"];
    });
  }

  showReason: any = [];
  getreason() {
    let data = {};
    this.UserService.GetReasonList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showReasonArray = res;
        this.showReason = [];
        for (const reasonData of this.showReasonArray["Data"]) {
          this.showReason.push({
            id: reasonData["ReasonId"],
            itemName: reasonData["ReasonName"],
          });
        }
      } else {
        this.showReasonArray = [];
      }
    });
  }
  selectedreason: any = [];
  selectedReason: any;
  selectedReasonId: number = 0;
  onReasonSelect(item: any) {
    this.selectedReason = "";
    this.selectedReasonId = 0;
    this.selectedreason.forEach((element) => {
      this.selectedReason += element["itemName"];
      this.selectedReasonId += element["id"];
    });
    if (this.selectedReasonId != 0 || this.selectedReasonId != null) {
      this.rqdReason = false;
    } else {
      this.rqdReason = true;
    }

    if (this.selectedReasonId == 6) {
      this.RL = true;
    } else {
      this.RL = false;
    }
  }

  getDuplicate() {
    if (this.selectedProjectId == 0 || this.selectedProjectId == null) {
      this.toastr.error("Please select a project to duplicate");
      return false;
    } else {
      this.isDisabled = true;
      let data = {
        InquiryId: this.id,
        ProjectId: this.selectedProjectId,
      };
      this.UserService.InquiryDuplicate(data).subscribe((res) => {
        this.spinner.show();
        if (res && res["result"] == "success") {
          this.newId = res["Data"]["InquiryNumber"];
          this.spinner.hide();
          this.toastr.success(
            "Inquiry duplicate generated SucessFully",
            this.newId
          );
          this.router.navigate(["/inquiry/inquirylist"]);
        } else if (res["result"] == "Failed") {
          this.spinner.hide();
          this.toastr.error(res["Msg"]);
        } else {
          this.spinner.hide();
          this.toastr.error(res['Msg'] || res['Message']);
        }
        this.submitted = false;
        this.isDisabled = false;
      });
    }
  }

  getReplica() {
    this.isDisabled = true;
    let data = {
      InquiryId: this.id,
    };
    this.UserService.InquiryReplica(data).subscribe((res) => {
      this.spinner.show();
      if (res && res["result"] == "success") {
        this.newId = res["Data"]["InquiryNumber"];
        this.spinner.hide();
        this.toastr.success(
          "Inquiry replica generated SucessFully",
          this.newId
        );
        this.router.navigate(["/inquiry/inquirylist"]);
      } else if (res["result"] == "Failed") {
        this.spinner.hide();
        this.toastr.error(res["Msg"]);
      } else {
        this.spinner.hide();
        this.toastr.error(res['Msg'] || res['Message']);
      }
      this.submitted = false;
      this.isDisabled = false;
    });
  }

  onItemSelect(item: any) {}
  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  onSubmit() {
    this.submitted = true;
    if (
      this.Lost &&
      (this.selectedReasonId == 0 ||
        this.selectedReasonId == null ||
        this.selectedReasonId == undefined)
    ) {
      this.rqdReason = true;
      return;
    } else {
      this.rqdReason = false;
    }

    if (
      this.Lost &&
      this.selectedReasonId == 6 &&
      (this.registerForm.value.LostReason == "" ||
        this.registerForm.value.LostReason == null)
    ) {
      this.rqdReasonDes = true;
      return;
    } else {
      this.rqdReasonDes = false;
    }

    if (this.registerForm.valid) {
      this.isDisabled = true;

      if (this.registerForm.value.LostReason && this.selectedReasonId == 6) {
        this.LostReasonDes = this.registerForm.value.LostReason;
      } else {
        this.LostReasonDes = "";
      }
      if (this.registerForm.value.QuoteMargin) {
        this.QuoteMargin = this.registerForm.value.QuoteMargin * 1;
      } else {
        this.QuoteMargin = 0;
      }
      if (this.registerForm.value.LOIMargin && this.loi) {
        this.LOIMargin = this.registerForm.value.LOIMargin * 1;
      } else {
        this.LOIMargin = 0;
      }
      if (this.registerForm.value.SOMargin && this.won) {
        this.SOMargin = this.registerForm.value.SOMargin * 1;
      } else {
        this.SOMargin = 0;
      }
      if (this.registerForm.value.LostTo == null || !this.Lost) {
        this.selectedCompanyId = 0;
        this.selectedReasonId = 0;
      }
      if (this.registerForm.value.RevisionNote == null) {
        this.registerForm.value.RevisionNote = "";
      }
      if (this.registerForm.value.ReceivedDate != "") {
        this.registerForm.value.ReceivedDate = moment(
          this.registerForm.value.ReceivedDate,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
      }
      if (
        this.registerForm.value.QuotedDate == null ||
        this.registerForm.value.QuotedDate == ""
      ) {
        this.registerForm.value.QuotedDate = null;
      } else {
        this.registerForm.value.QuotedDate = moment(
          this.registerForm.value.QuotedDate,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
      }
      if (
        this.registerForm.value.ExpOrderDate == null ||
        this.registerForm.value.ExpOrderDate == ""
      ) {
        this.registerForm.value.ExpOrderDate = null;
      } else {
        this.registerForm.value.ExpOrderDate = moment(
          this.registerForm.value.ExpOrderDate,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
      }
      this.spinner.show();
      let data = {
        ProjectId: this.registerForm.value.ProjectId,
        ProjectName: this.Pname,
        ProjectSource: 0,
        Territory: 0,
        InquiryId: this.id,
        InquiryName: this.Iname,
        CustomerName: this.selectedCustomerId,
        MEPContractor: this.selectedContractorId,
        MainContractor: this.selectedMainContractorId,
        DesignConsultant: this.selectedConsultantId,
        SupervisionConsultant: this.selectedSupervisionId,
        StageId: this.selectedStageId,
        InquiryProbability: this.selectedProbabilityId,
        ReceivedDate: this.registerForm.value.ReceivedDate,
        QuotationEngineerId: this.selectedQuotationErId,
        SalesEngineerId: this.selectedSalesErId,
        BusinessVertical: this.selectedBusinessNameId,
        BusinessCategory: this.selectedCategoryId,
        QuotedValue: this.registerForm.value.QuotedValue,
        ReportedValue: this.registerForm.value.ReportedValue,
        QuotedDate: this.registerForm.value.QuotedDate,
        IncoTerms: this.registerForm.value.IncoTerms,
        Application: this.registerForm.value.Application,
        ExpOrderDate: this.registerForm.value.ExpOrderDate,
        LostTo: this.selectedCompanyId,
        Reason: this.selectedReasonId,
        LostReason: this.LostReasonDes,
        QuoteMargin: this.QuoteMargin,
        LOIMargin: this.LOIMargin,
        SOMargin: this.SOMargin,
        Revision: this.selectedRevisionId2,
        RevisionNote: this.registerForm.value.RevisionNote,
      };
      this.UserService.AddProjectInquiry(data).subscribe(
        (res) => {
          if (res && res["result"] == "success") {
            this.spinner.hide();
            this.toastr.success("Inquiry updated successfully");
            this.router.navigate(["/inquiry/inquirylist"]);
          } else if (res["result"] == "Failed") {
            this.toastr.error(res["Msg"]);
            this.spinner.hide();
          } else {
            this.toastr.error(res['Msg'] || res['Message']);
            this.spinner.hide();
          }
          this.isDisabled = false;
          this.submitted = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastr.error(err.Msg || err.Message);
          }
          this.isDisabled = false;
        }
      );
    }
  }

  editIqrid = this.route.snapshot.params["id"];
  tabclick(id) {
    localStorage.setItem("active_id", "tab-selectbyid1");
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate(["/inquiry/editinquiry", encryptid]);
  }
  tabclick1(id) {
    localStorage.setItem("active_id", "tab-selectbyid2");
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate(["/inquiry/editinquiry",encryptid,"inquirydocument",]);
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }

  validateReasonDes(event: any) {
    let RegEx = new RegExp(/^(\w+\s?)*\s*$/);
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      str = str.replace(/\s+/g, " ");
      str = str.replace(
        /[^a-zA-Z0-9\d!@#$&()\\-`.+,\%\*\-\=\|\~\[\]\{\}/\\<\>\?\'\"\;\:"]+/g,
        " "
      );
      event.target.value = str.replace(/^\s+/g, "");
    }
  }

  cleardate() {
    this.registerForm.get("ExpOrderDate").setValue("");
  }
}
